import React from 'react'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'
import PostLink from '../components/post-link'
import get from 'lodash/get'
import Layout from '../components/layout'

class BlogPage extends React.Component {
  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')
    var posts = get(this, 'props.data.allMarkdownRemark.edges')
    const color = '#d3e8e1'
    const category = 'Blog'
    const description = 'Articles on Diversity & Inclusion'

    if (!posts) {
      posts = []
    }
    return (
      <Layout location={this.props.location} style={{ backgroundColor: color }}>
        <Helmet
          htmlAttributes={{ lang: 'en' }}
          meta={[
            { name: 'description', content: description },
            { property: 'og:title', content: category },
            {
              property: 'og:description',
              content: description,
            },
            {
              name: 'twitter:title',
              content: category,
            },
            {
              name: 'twitter:description',
              content: description,
            },
          ]}
          title={siteTitle}
        />

        <div
          className="p-6"
          style={{ backgroundColor: color, maxWidth: '100%' }}
        >
          <h1>{category}</h1>
          <p className="text-xl">{description}</p>
        </div>

        <div className="flex flex-col p-6">
          {posts.map(({ node }) => {
            return <PostLink key={node.id} post={node} />
          })}
        </div>
      </Layout>
    )
  }
}

export default BlogPage

export const pageQuery = graphql`
  query {
    allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] }
      filter: { frontmatter: { type: { ne: "story" } } }
    ) {
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            path
            title
            description
            cover_image {
              publicURL
              childImageSharp {
                fluid(maxWidth: 1000) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`
